import type { Market } from '@/libs/sdk/api';

export type EventMarketGroup = {
  eventId: string;
  markets: Market[];
};

export const groupMarketsByEvent = (markets: Market[]): EventMarketGroup[] => {
  const groups = new Map<string, Market[]>();

  for (const market of markets) {
    const eventId = market.eventId || market.marketAddress;
    const current = groups.get(eventId);
    if (current) {
      current.push(market);
      continue;
    }
    groups.set(eventId, [market]);
  }

  return Array.from(groups.entries()).map(([eventId, groupedMarkets]) => ({
    eventId,
    markets: groupedMarkets,
  }));
};

/**
 * Drop groups that hold a single leg of a multi-market event. A paged window
 * (the trending rail reads one volume-ranked page) can cut an event apart, and
 * the leg that made the cut then renders as a standalone card whose short name
 * ("3.6% or higher", "Net inflow") means nothing without its event title.
 * A genuine standalone market names itself after its event, a leg does not.
 *
 * Only for windowed views -- the browse list pages through every leg eventually,
 * so filtering there would hide markets outright.
 */
export const dropTruncatedEventLegs = (groups: EventMarketGroup[]): EventMarketGroup[] =>
  groups.filter(group => group.markets.length > 1 || group.markets[0].marketName === group.markets[0].eventTitle);
